module.exports = __webpack_public_path__ + "static/media/pearshape.73e99226.jpg";